import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { faqList } from "@/mocks/faqs";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Faq() {
  useDocumentTitle(
    "常见问题 - 光棍影院",
    "光棍影院常见问题解答，涵盖观看方式、收藏说明、搜索筛选、内容更新等常见疑问，帮助你更快了解站点功能。"
  );

  const [openId, setOpenId] = useState<string | null>(faqList[0]?.id ?? null);

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 w-full px-4 md:px-8 pt-24 md:pt-28 pb-14">
        <nav className="text-sm text-foreground-500 mb-4 flex items-center gap-1.5">
          <Link to="/" className="hover:text-primary-600 transition-colors">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-800 font-medium">常见问题</span>
        </nav>

        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h1>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            关于光棍影院的使用疑问，这里为你一一解答。点击问题即可展开或收起答案。
          </p>

          <div className="mt-8 flex flex-col gap-3">
            {faqList.map((faq) => {
              const open = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`rounded-lg border transition-colors ${
                    open
                      ? "border-primary-300 bg-background-100"
                      : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : faq.id)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h2 className="text-sm md:text-base font-semibold text-foreground-950 flex items-center gap-2">
                      <span
                        className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${
                          open
                            ? "bg-accent-500 text-foreground-950"
                            : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        Q
                      </span>
                      {faq.question}
                    </h2>
                    <i
                      className={`text-xl shrink-0 transition-transform ${
                        open ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"
                      }`}
                    ></i>
                  </button>
                  {open && (
                    <div className="px-5 pb-5 pt-0 pl-14 animate-fade-in">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="text-sm font-semibold text-foreground-950">没有找到你的问题？</p>
              <p className="text-sm text-foreground-500 mt-0.5">
                欢迎通过关于我们页面的反馈表单联系我们
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap shrink-0"
            >
              <i className="ri-mail-send-line"></i>
              联系我们
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}